module.exports = __webpack_public_path__ + "img/cmc.46287b67.png";